import { z } from "zod";
export const SECTOR_COLOR_SLOT_POOL_ID = "sector";
export const ENERGY_SOURCE_COLOR_SLOT_POOL_ID = "energySource";
export const SCOPE_COLOR_SLOT_POOL_ID = "scope";
export const MAX_CHART_COLOR_SLOT_POOL_COUNT = 200;
export const MAX_CHART_COLOR_SLOT_KEY_COUNT = 500;
const MAX_CHART_COLOR_SLOT_ID_LENGTH = 200;
const CHART_COLOR_SLOT_ID_REGEX = /^[A-Za-z0-9_:-]+$/;
const chartColorSlotIdSchema = z.string().min(1).max(MAX_CHART_COLOR_SLOT_ID_LENGTH).regex(CHART_COLOR_SLOT_ID_REGEX);
const slotByKeySchema = z
    .record(chartColorSlotIdSchema, z.number().int().nonnegative())
    .refine((slotByKey) => Object.keys(slotByKey).length <= MAX_CHART_COLOR_SLOT_KEY_COUNT);
export const chartColorSlotConfigSchema = z
    .record(chartColorSlotIdSchema, slotByKeySchema)
    .refine((config) => Object.keys(config).length <= MAX_CHART_COLOR_SLOT_POOL_COUNT);
export const chartColorSlotRequestSchema = z.object({
    poolId: chartColorSlotIdSchema,
    keyList: z.array(chartColorSlotIdSchema).max(MAX_CHART_COLOR_SLOT_KEY_COUNT),
});
export const isChartColorSlotId = (value) => chartColorSlotIdSchema.safeParse(value).success;
export const buildSubsectorColorSlotPoolId = (parentSectorId) => `subsector:${parentSectorId}`;
export function parseChartColorSlotConfig(value) {
    if (value === null || value === undefined) {
        return null;
    }
    const result = chartColorSlotConfigSchema.safeParse(value);
    return result.success ? result.data : null;
}
function findLowestFreeSlot(usedSlotSet, startSlot) {
    let slot = startSlot;
    while (usedSlotSet.has(slot)) {
        slot += 1;
    }
    return slot;
}
export function assignChartColorSlots(slotByKey, keyList) {
    const nextSlotByKey = new Map(Object.entries(slotByKey));
    const usedSlotSet = new Set(nextSlotByKey.values());
    let candidateSlot = 0;
    for (const key of keyList) {
        if (nextSlotByKey.has(key)) {
            continue;
        }
        candidateSlot = findLowestFreeSlot(usedSlotSet, candidateSlot);
        nextSlotByKey.set(key, candidateSlot);
        usedSlotSet.add(candidateSlot);
    }
    return Object.fromEntries(nextSlotByKey);
}
export function mergeChartColorSlotRequestList(config, requestList) {
    const nextConfig = new Map(Object.entries(config));
    let hasChanges = false;
    for (const { poolId, keyList } of requestList) {
        if (!nextConfig.has(poolId) && nextConfig.size >= MAX_CHART_COLOR_SLOT_POOL_COUNT) {
            continue;
        }
        const slotByKey = nextConfig.get(poolId) ?? {};
        const assignedKeySet = new Set(Object.keys(slotByKey));
        const freeKeyCount = MAX_CHART_COLOR_SLOT_KEY_COUNT - assignedKeySet.size;
        const newKeyList = [...new Set(keyList.filter((key) => !assignedKeySet.has(key)))].slice(0, freeKeyCount);
        const nextSlotByKey = assignChartColorSlots(slotByKey, newKeyList);
        if (Object.keys(nextSlotByKey).length !== Object.keys(slotByKey).length) {
            nextConfig.set(poolId, nextSlotByKey);
            hasChanges = true;
        }
    }
    return { config: Object.fromEntries(nextConfig), hasChanges };
}
